import { useMutation } from "react-query";
import { getScoreCardDownload } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useScoreCardDownload = () => {
  return useMutation(getScoreCardDownload);
};
export default useScoreCardDownload;
